import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { manageFootballSeasonService } from "../../../../../../commons";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { IKnockoutDTO } from "../../../../../../api-services/football/admin/manage-football-season-service";

export interface IManageKnockoutCreateState {
  seasonKnockoutCreateResponseStatus: StatusEnum;
}

export interface IManageKnockoutAddOption {
  seasonId: number;
  seasonKnockoutInfo: IKnockoutDTO;
  urlParams?: {
    hostTeamId?: number;
  };
}

const initialState: IManageKnockoutCreateState = {
  seasonKnockoutCreateResponseStatus: StatusEnum.Idle,
};

export const seasonKnockoutCreate = createAsyncThunk(
  "manage/seasonKnockoutCreate",
  async (options: IManageKnockoutAddOption, thunkAPI) => {
    try {
      const competitionGroupList = await manageFootballSeasonService.createSeasonKnockout(
        options.seasonId,
        options.seasonKnockoutInfo,
        options.urlParams
      );
      return competitionGroupList;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageSeasonKnockoutCreateResponseSlice = createSlice({
  name: "manageKnockoutCreate",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(seasonKnockoutCreate.pending, (state) => {
        state.seasonKnockoutCreateResponseStatus = StatusEnum.Loading;
      })
      .addCase(seasonKnockoutCreate.fulfilled, (state) => {
        state.seasonKnockoutCreateResponseStatus = StatusEnum.Succeeded;
      })
      .addCase(seasonKnockoutCreate.rejected, (state) => {
        state.seasonKnockoutCreateResponseStatus = StatusEnum.Failed;
      });
  },
});

export default manageSeasonKnockoutCreateResponseSlice.reducer;
